
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","data-name":"vuesax/twotone/document-text"}},[_c('path',{attrs:{"d":"M35 11.666v16.667c0 5-2.5 8.333-8.333 8.333H13.333C7.5 36.666 5 33.333 5 28.333V11.666c0-5 2.5-8.333 8.333-8.333h13.334C32.5 3.333 35 6.666 35 11.666z","stroke":"#245389"}}),_c('path',{attrs:{"data-name":"Vector","d":"M24.167 7.5v3.333a3.343 3.343 0 003.333 3.334h3.334M13.333 21.667H20M13.333 28.333h13.333","stroke":"#f29030"}})])])
          )
        }
      }
    